export const addMinSearchScoreToGetSomeRequest = <T extends { search?: { query?: string; minSearchScore?: number } }>(
  originalRequest: T,
  minSearchScore?: number
): T => {
  if (!originalRequest.search?.query) return originalRequest;
  if (minSearchScore === undefined) return originalRequest;

  return {
    ...originalRequest,
    search: {
      minSearchScore,
      ...originalRequest.search,
    },
  };
};
